export class AddSubLocation {
  static readonly type = '[Contract.SubLocation] Add Sub Location';
  constructor(public subLocation: any, public locID?: number) {}
}

export class UpdateSubLocation {
  static readonly type = '[Contract.SubLocation] Update Sub Location';
  constructor(public subLocation: any, public locID?: number) {}
}

export class DeleteSubLocation {
  static readonly type = '[Contract.SubLocation] Delete Sub Location';
  constructor(public locID: number, public subLocID: number) {}
}

export class OnLocationDeleted {
  static readonly type = '[Contract.Location] On Location Deleted';
  constructor(public locID: number) {}
}

export class CloneSubLocation {
  static readonly type = '[Contract.SubLocation] Clone Sub Location';
  constructor(public locID: number, public subLocID: number, public copies: number = 1) {}
}

export class RestoreSubLocation {
  static readonly type = '[Contract.SubLocation] Restore Sub Location';
  constructor(public locID: number, public subLocID: number) {}
}

export class SetCurrentSubLocation {
  static readonly type = '[Contract.SubLocation] Set Current Sub Location';
  constructor(public subLocation: any) {}
}

export class SetCurrentSubLocationParent {
  static readonly type = '[Contract.SubLocation] Set Current Parent Location';
  constructor(public locNum: string = null) {}
}
